import { Component } from '@angular/core';

@Component({
    selector: 'app-workshop-list',
    imports: [],
    templateUrl: './workshop-list.component.html',
    styleUrl: './workshop-list.component.css'
})
export class WorkshopListComponent {

}
